// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"6cb1accf","179":"8c26893f","327":"b4afb413","488":"22b449f6","554":"32cd51d0","586":"01986fad","595":"a7eac1e7","641":"d5d392c7","728":"5abc8d90","731":"9c30807d","812":"6b3b47f2","969":"211e42c2","979":"7012818d"}[chunkId] + ".chunk.js";
};